<template>
  <component :is="component" class="scrollnavigation">
    <ButtonComponent
      v-for="{ selector, label } in value"
      :key="selector"
      class="scrollnavigation__item"
      :class="{ 'scrollnavigation__item--active': active === selector }"
      @click="scroll(selector)"
    >
      <template #label>{{ label }}</template>
    </ButtonComponent>
  </component>
</template>

<script>
export default {
  props: {
    component: {
      type: [String, Object],
      default: 'div',
    },
    value: {
      type: Array,
      required: true,
    },
    offset: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      active: null,
      observer: null,
      state: new Map(),
    }
  },
  methods: {
    init() {
      const options = {
        root: null,
        rootMargin: `-${this.offset}px 0px -50% 0px`,
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const { isIntersecting, intersectionRatio: ratio, target } = entry
          if (isIntersecting) this.state.set(target.selector, ratio)
          else this.state.delete(target.selector)
        })

        let maxRatio = 0
        let mostVisibleSection = null

        this.state.forEach((ratio, selector) => {
          if (ratio <= maxRatio) return

          maxRatio = ratio
          mostVisibleSection = selector
        })

        if (mostVisibleSection) this.active = mostVisibleSection
      }, options)

      this.$nextTick(() => {
        this.value.forEach(section => {
          const element = document.querySelector(section.selector)
          if (!element) return

          this.observer.observe(element)
        })

        this.check()
      })
    },
    scroll(selector) {
      const element = document.querySelector(selector)
      if (!element) return

      window.scrollTo({
        top: element.offsetTop - this.offset,
        behavior: 'smooth',
      })

      this.active = selector
    },
    check() {
      const scrollPosition = window.scrollY + this.offset + 10

      this.value.forEach(({ selector }) => {
        const element = document.querySelector(selector)
        if (!element || element.offsetTop > scrollPosition) return

        this.active = selector
      })

      if (!this.active && this.value.length > 0) this.active = this.value[0].selector
    },
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    this.state.clear()
  },
}
</script>

<style lang="scss">
.scrollnavigation {
  position: sticky;
  top: 70px;
  align-self: start;

  *:has(> .scrollnavigation__item),
  &:has(> .scrollnavigation__item) {
    display: flex;
    flex-direction: column;
  }

  &__item {
    text-align: left;
    background: transparent;
    border: none;

    &:hover {
      background: #f5f5f5;
    }

    &--active {
      background: #eaeaea;
    }

    &::before {
      display: none;
    }
  }
}
</style>
